import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=1b14d114&scoped=true&"
import script from "./forms.vue?vue&type=script&lang=js&"
export * from "./forms.vue?vue&type=script&lang=js&"
import style0 from "./forms.vue?vue&type=style&index=0&id=1b14d114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b14d114",
  null
  
)

export default component.exports